import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = ["value"]

import { inject, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortOptions',
  props: {
    sorting: {},
    sortingOptions: {}
  },
  emits: ["change"],
  setup(__props: any, { emit }) {

const props = __props;





const i18n = inject('i18n') as { [key: string]: string };
const selectedSorting = ref(props.sorting);
const selectId = 'sorting-' + (Math.random() + 0.1).toString(36).substring(2, 5);

function handleChange (event: Event) {
    const newSorting = (event.target as HTMLSelectElement).value.replace('_', ' ');
    selectedSorting.value = newSorting;
    emit('change', newSorting);
}

function valueKey (key: string | number) {
    return key.toString().replace(' ', '_');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      for: selectId,
      class: "visually-hidden"
    }, _toDisplayString(_unref(i18n).sortingBy) + ": ", 1 /* TEXT */),
    _createCommentVNode(" eslint-disable-next-line vuejs-accessibility/no-onchange "),
    _createElementVNode("sl-select", {
      id: selectId,
      placeholder: _unref(i18n).sortingBy,
      onSlChange: handleChange
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortingOptions, (name, key) => {
        return (_openBlock(), _createElementBlock("sl-option", {
          key: key,
          value: valueKey(key)
        }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_2))
      }), 128 /* KEYED_FRAGMENT */))
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})